<template>
  <div class="content">
      <div class="cover-img" style="background-image: url(/static/img/slide4.jpg);">
        <div class="cover">
          <h1>
            {{$t('faq.body_title')}}
          </h1>
        </div>
      </div>
      <div class="container">
        <div class="page">
          <div class="loader" v-if="loading">
            <loader/>
          </div>
          <template v-else>
            <faq-search />
            <faq-category v-for="(item, index) in categories" :category="item" :index="index" :key="item.id"/>
          </template>
        </div>
      </div>
    </div>
</template>

<script>
import "../../../static/style3/faq.css";
import Loader from '../../components/loader.component';
import {mapGetters, mapState} from "vuex";
import Category from "./category";
import FaqSearch from "./faq-search";

export default {
  name: "faq",
  components: {FaqSearch, faqCategory: Category, Loader},
  computed: {
    loading () {
      return this.$store.getters["faq/loading"];
    },
    categories () {
      return this.$store.getters["faq/categories"];
    },
    ...mapGetters({
      isAuth: 'isAuth',
      lang: 'lang'
    })
  },
  watch: {
      async isAuth (v) {
        await this.init();
      },
      async lang (v) {
        await this.init();
      }
  },
  async mounted () {
    await this.init();
  },
  methods: {
    async init () {
      if (this.isAuth) {
        await this.$store.dispatch('faq/fetchAuthBookings');
      }
      await this.$store.dispatch('faq/fetch', {
        lang: this.lang
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/faq/faq.vue